export default __webpack_public_path__ + "static/media/Mask Group 19.1f45a526.png";